module.exports = __webpack_public_path__ + "static/media/stemcellserumrestructuractive.0874df2a.png";